import { Formik } from 'formik';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { stepFeedbackFulfilled } from '../../../../actions/registerShipmentActions';
import { H4 } from '../../../base/typography';
import { stepFeedbackSchema } from './stepFeedback.schema';
import * as StyledStepFeedback from './stepFeedback.styles';
import StepFeedbackForm from './stepFeedbackForm/stepFeedbackForm';

interface StepFeedbackFormValues {
	rating: number;
	feedback: string;
}
export interface StepFeedbackInfo {
	shipmentId: string;
	clientId: string;
	domestic: boolean;
	loggedIn: boolean;
}

interface Props {
	info: StepFeedbackInfo;
	showFullForm?: boolean;
}

const StepFeedback: FC<Props> = ({ info, showFullForm = false }) => {
	const { t } = useTranslation('registerShipment');
	const dispatch = useDispatch();

	const {
		registerShipmentReducer: { stepFeedbackFormInfo },
	} = useSelector((store: any) => store);

	const onStepFeedbackSubmit = (values: StepFeedbackFormValues) => {
		dispatch(stepFeedbackFulfilled(values));
	};

	return (
		<StyledStepFeedback.Wrapper>
			<div>
				<H4 style={{ textAlign: 'center' }}>{t('shared.registrationQuestion')}</H4>
			</div>
			<Formik
				initialValues={{
					rating: stepFeedbackFormInfo?.rating || 0,
					feedback: stepFeedbackFormInfo?.feedback || '',
				}}
				enableReinitialize
				validationSchema={stepFeedbackSchema}
				onSubmit={onStepFeedbackSubmit}>
				{({ values, setFieldValue }) => (
					<StepFeedbackForm
						showFullForm={showFullForm}
						values={values}
						info={info}
						setFieldValue={setFieldValue}
					/>
				)}
			</Formik>
		</StyledStepFeedback.Wrapper>
	);
};

export default StepFeedback;
